/** Money input shared by the lead drawer (ARV overrides) and the deal editor.
 * Commits on blur/Enter as v1's "$X,XXX" display-string format; empty clears
 * (null). Local text state only — durability is the outbox's job. */
import { useRef, useState } from "react";
import { fmtMoneyEdit, parseMoneyEdit } from "../edits/api";

export function MoneyText({
  initial,
  placeholder,
  onCommit,
}: {
  initial: string | null;
  placeholder: string;
  onCommit: (v: string | null) => void;
}) {
  const initNum = parseMoneyEdit(initial);
  const [text, setText] = useState(initNum === null ? "" : String(initNum));
  const last = useRef<number | null>(initNum);
  const commit = () => {
    const raw = text.trim();
    const v = raw === "" ? null : (parseMoneyEdit(raw) ?? last.current);
    if (v === last.current) {
      setText(v === null ? "" : String(v));
      return;
    }
    last.current = v;
    setText(v === null ? "" : String(v));
    onCommit(v === null ? null : fmtMoneyEdit(v));
  };
  return (
    <input
      className="moneyinput"
      inputMode="numeric"
      value={text}
      placeholder={placeholder}
      onChange={(e) => setText(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => e.key === "Enter" && (e.target as HTMLInputElement).blur()}
    />
  );
}
